import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { Stack } from '@mui/material';
import GlobalTable from '../../../components/CustomTableWithPagination/GlobalTable';
import { useDispatch } from 'react-redux';
import { getDepartmentEmployeesTable } from '../../../redux/features/crdMigrationSlice';
import { DepartmentEmployeesHeader } from './utils/DepartmentEmployeesHeader';
import { useSelector } from 'react-redux';

export default function DepartmentEmployees() {
  const dispatch = useDispatch();

  //------------------localstorage------------

  const cred = localStorage.getItem('cred');
  const departmentName = cred ? JSON.parse(cred)?.profile?.departmentName : '';

  // Redux State-------------------------------------------------------------
  const loading = useSelector((state) => state.crdMigration.departmentEmployeesTable.loading);
  const tableData = useSelector((state) => state.crdMigration.departmentEmployeesTable.data);
  const meta = useSelector((state) => state.crdMigration.departmentEmployeesTable.meta);

  //--------------------------------------------------------

  // react state-------------------------------

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const dispatchParams = useMemo(
    () => ({
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      sortBy: tableState?.sort?.field,
      sortDirection: tableState?.sort?.direction,
      departmentName,
    }),
    [tableState?.page, tableState?.search, tableState?.sort, tableState?.pageSize, departmentName],
  );

  //------------TAble Fetch-------------
  useEffect(() => {
    dispatch(getDepartmentEmployeesTable(dispatchParams));
  }, [dispatchParams, dispatch]);

  //------------TAble Fetch-------------

  return (
    <GlobalWrapper title={'My Department Employees'}>
      <Stack gap={2}>
        <GlobalTable
          rowUniqueId="sl_no"
          headers={DepartmentEmployeesHeader}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          rows={tableData || []}
          meta={meta ?? {}}
        />
      </Stack>
    </GlobalWrapper>
  );
}
